export abstract class BaseSetupStepComponent {
    static readonly bindings = {
        open: '<',
        onOpen: '&',
        onClose: '&',
    };

    open = false;
    onOpen?: () => any;
    onClose?: () => any;

    onOpenChanged(open: boolean) {
        if (open) {
            return this.emitOpen();
        }

        this.emitClose();
    }

    emitOpen() {
        this.onOpen && this.onOpen();
    }

    emitClose() {
        this.onClose && this.onClose();
    }
}
